import {barChartPrototypes, barChartPrototypesDefaults, ChartFormatterTypes} from "../Charts/bar-chart-prototypes"

const chartFormatter = (formatterType) => {
    const map = {
        [ChartFormatterTypes.EURO_NO_DECIMALS]: (value) => Intl.NumberFormat("de-DE", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            currency: "EUR",
        }).format(value),
        [ChartFormatterTypes.EURO_TWO_DECIMALS]: (value) => Intl.NumberFormat("de-DE", {
            style: "currency",
            currency: "EUR",
        }).format(value),
        [ChartFormatterTypes.PERCENT_NO_DECIMALS]: (value) => Intl.NumberFormat("de-DE", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            style: "percent",
        }).format(value / 100),
        [ChartFormatterTypes.PERCENT_TWO_DECIMALS]: (value) => Intl.NumberFormat("de-DE", {
            style: "percent",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value / 100),
        [ChartFormatterTypes.NUMBER_NO_DECIMALS]: (value) => Intl.NumberFormat("de-DE", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        }).format(value),
        [ChartFormatterTypes.NUMBER_TWO_DECIMALS]: (value) => Intl.NumberFormat("de-DE", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value),
    }
    return map[formatterType] ?? ((val) => val)
}

export const calculatePercentage = (percentage) => Number.parseInt(
    percentage || barChartPrototypesDefaults.barPercentage,
) / 100

const generateTomDefault = (tomOptions) => Object
    .fromEntries(
        Object.keys(barChartPrototypes).map(key => [
            key,
            tomOptions[key] ?? barChartPrototypesDefaults[key],
        ]),
    )

export const defaultBarOptions = (bottomLabels, tomOptions = {}) => {
    const tomDefault = generateTomDefault(tomOptions)
    const tom = {
        ...tomDefault,
        yAxisFormatter: chartFormatter(tomDefault.yAxisFormatter),
        tooltipFormatter: chartFormatter(tomDefault.tooltipFormatter),
    }

    return ({
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            tooltip: {
                bodyAlign: "center",
                bodyFont: {
                    family: "Urbanist",
                    weight: "bold",
                    size: 14,
                },
                callbacks: {
                    label: (context) => `${context.dataset.label ?? ""}: ${tom.tooltipFormatter(context.raw)}`,
                },
            },
        },
        datasets: {
            bar: {
                borderRadius: 4,
                barPercentage: calculatePercentage(tom.barPercentage),
                maxBarThickness: Number.parseInt(tom.maxBarThickness || barChartPrototypesDefaults.maxBarThickness),
            },
        },
        scales: {
            x: {
                border: {
                    display: false,
                },
                position: "top",
                stacked: true,
                grid: {
                    display: tom.xGridDisplay,
                },
                ticks: {
                    display: tom.xTicksDisplay,
                    font: {
                        family: "Urbanist",
                        weight: "bold",
                        size: 14,
                    },
                    minRotation: 0,
                    maxRotation: 0,
                },
            },
            y: {
                border: {
                    display: false,
                },
                stacked: true,
                grid: {
                    display: tom.yGridDisplay,
                },
                ticks: {
                    display: tom.yTicksDisplay,
                    callback: tom.yAxisFormatter,
                },
            },
            titles: {
                border: {
                    display: false,
                },
                stacked: true,
                position: "bottom",
                grid: {
                    display: false,
                },
                ticks: {
                    display: tom.titlesTicksDisplay,
                    font: {
                        family: "Urbanist",
                        weight: "bold",
                        size: 14,
                    },
                    callback: (_, index) => bottomLabels[index],
                },
            },
        },
    })
}
